import client from '../../utils/api'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'substitute'
const initialState = {
  list: null,
  subs: null,
  subsLoading: false,
  subsError: null,
  loading: false,
  error: null,
}


export const search = createApiAction('substitute/search', client.search('/api/substitute/portal'))
export const get = createApiAction('substitute/get', client.retrieve('/api/substitute/portal/:personId'))
export const getSubs = createApiAction('substitute/getSubs', client.search('/api/substitute/portal/subPeriods'))
export const getSubAssignment = createApiAction('substitute/get', client.retrieve('/api/substitute/portal/:substituteId'))
// export const save = createApiAction('substitute/save', client.save('/api/substitute/portal'))
export const save = createAsyncThunk(
  'substitute/save',
  async ({ date, personId, submissions }) => {
    const url = `/api/substitute/portal?date=${encodeURIComponent(date)}&personId=${encodeURIComponent(personId)}`;
    const response = await client.post(url, submissions);
    return response.data
  }
);

const update = (state, action) => {
    const updatedItem = action.payload;
  
    if (state.list.some(item => item.personId === updatedItem.personId)) {
      state.list = state.list.map(item =>
        item.personId === updatedItem.personId ? { ...item, ...updatedItem } : item
      );
    } else {
      state.list = [...state.list, updatedItem];
    }

    
  };

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    clearSubs: state => {
      state.list = null
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(search.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading = false;
      })
      .addCase(getSubs.pending, (state) => {
        state.subsLoading = true;
        state.subsError = null;
      })
      .addCase(getSubs.fulfilled, (state, action) => {
        state.subs = action.payload;
        state.subsLoading = false;
      })
      .addCase(get.fulfilled, update)
      .addCase(save.fulfilled, update)
  },
})

export const { clearSubs } = sessionSlice.actions
export default sessionSlice.reducer
